// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__3pylN","title":"AfterBackImages_title__1uI0k","images":"AfterBackImages_images__y_Pjb"};